import 'maplibre-gl/dist/maplibre-gl.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/shell.css';
import './styles/map.css';

import { render } from 'preact';
import { App } from './app/App';

const root = document.getElementById('root');

if (!root) {
  throw new Error('CHAOC root element is missing');
}

render(<App />, root);
